<template>
  <section class="awl">
    <div class="awl__head"><h2 class="awl__title">Carga por agente</h2></div>
    <div v-if="items && items.length" class="awl__list">
      <div v-for="a in items" :key="a.name" class="awl__row">
        <span class="awl__name">{{ a.name }}</span>
        <span class="awl__bar"><span :style="{ width: pct(a.open) + '%' }"></span></span>
        <span class="awl__count">{{ a.open }}</span>
      </div>
    </div>
    <div v-else class="awl__empty">Sin consultas abiertas asignadas.</div>
  </section>
</template>

<script>
export default {
  props: { items: { type: Array, default: () => [] } },
  computed: {
    max() {
      return Math.max(1, ...this.items.map(a => a.open || 0));
    }
  },
  methods: {
    pct(n) {
      return Math.round(((n || 0) / this.max) * 100);
    }
  }
};
</script>

<style scoped>
.awl { background: #fff; border: 1px solid #ece7de; border-radius: 14px; padding: 18px 20px; box-shadow: 0 8px 24px -16px rgba(40, 33, 22, 0.18); margin-bottom: 22px; }
.awl__head { margin-bottom: 12px; }
.awl__title { font-size: 16px; font-weight: 700; color: #1a1814; margin: 0; }
.awl__list { display: flex; flex-direction: column; gap: 10px; }
.awl__row { display: grid; grid-template-columns: minmax(90px, max-content) 1fr 30px; align-items: center; gap: 12px; }
.awl__name { font-size: 13px; font-weight: 600; color: #1a1814; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.awl__bar { height: 7px; border-radius: 999px; background: #f1ece3; overflow: hidden; }
.awl__bar span { display: block; height: 100%; border-radius: 999px; background: #2353b8; }
.awl__count { font-size: 13px; font-weight: 700; color: #1a1814; text-align: right; }
.awl__empty { color: #a39a8c; font-size: 13.5px; padding: 6px 0; }
</style>
